import { Trans } from 'react-i18next';

import { Checkbox, Link, LinkTarget } from '@dreryk/react-components';

import { invoiceCreateAccountModalTranslationKeys } from '../../../translations';

import { InvoiceCreateAccountFormRegisterControllerProp } from './InvoiceCreateAccountForm.types';

const TERMS_AND_CONDITIONS_FIELD_NAME = 'termsAndConditionsAccepted';

type InvoiceCreateAccountFormTermsAndConditionsCheckboxProps = InvoiceCreateAccountFormRegisterControllerProp & {
   readonly termsAndConditionsUrl: string;
};

export const InvoiceCreateAccountFormTermsAndConditionsCheckbox = (
   props: InvoiceCreateAccountFormTermsAndConditionsCheckboxProps
): JSX.Element => {
   return (
      <Checkbox
         controller={props.register(TERMS_AND_CONDITIONS_FIELD_NAME, { required: true })}
         testId={TERMS_AND_CONDITIONS_FIELD_NAME}
         label={
            <Trans
               i18nKey={invoiceCreateAccountModalTranslationKeys.termsLabel}
               components={{
                  link: (
                     <Link
                        block={false}
                        href={props.termsAndConditionsUrl}
                        label={invoiceCreateAccountModalTranslationKeys.terms}
                        target={LinkTarget.BLANK}
                        testId={'goToTermsAndConditions'}
                     />
                  ),
               }}
            />
         }
      />
   );
};
